var _slicedToArray = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _classCallCheck = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var OrangeChartAxis = require('./orange-chart-axis');
var _require = require('orange-svg'),
  OrangeSVG = _require.OrangeSVG;

/**
 * Abstract chart
 *
 * @abstract
 */
var OrangeChartAbstract = /*#__PURE__*/function () {
  "use strict";

  /**
   *
   * @param {object[]} data Array of data rows
   */
  function OrangeChartAbstract(data) {
    _classCallCheck(this, OrangeChartAbstract);
    if (data.length < 1) throw new Error('Data array is empty');
    this._data = data;
    this._source_mapping = [];
    this._default_data_callbacks = {};
    this._custom_data_callbacks = {};
    this._axes = {};
    var _iterator = _createForOfIteratorHelper(this.constructor.allowed_axes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var axis = _step.value;
        this._axes[axis] = new OrangeChartAxis(axis);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  /**
   * Returns allowed axes for the chart
   *
   * @type {string[]}
   * @static
   * @abstract
   */
  _createClass(OrangeChartAbstract, [{
    key: "assignSource",
    value:
    /**
     * Assigns property of data set's objects to be used for source axis
     *
     * @param {string} property
     * @param {?string} color
     * @param {object} callbacks JavaScript callbacks for elements created for representation of the value per property
     * @return {OrangeChartAbstract}
     */
    function assignSource(property) {
      var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this._source_mapping.push({
        property: property,
        color: color
      });
      if (this.constructor.allowed_axes.includes(this.constructor.source_axis)) {
        this._axes[this.constructor.source_axis].update({
          'sources': this._source_mapping.map(function (v) {
            return v.property;
          })
        }, this._data);
      }
      this._custom_data_callbacks[property] = callbacks;
      return this;
    }

    /**
     * Defines default JavaScript callbacks for elements created for representation of the value
     *
     * @param {string} event_name Event name line "click", "mouseover", "mouseleave"
     * @param {function} callback Callback function with arguments: event (DOM Event), object
     * @return {OrangeChartAbstract}
     */
  }, {
    key: "setDataCallback",
    value: function setDataCallback(event_name, callback) {
      this._default_data_callbacks[event_name] = callback;
      return this;
    }

    /**
     * Returns callback by property name (default if custom were not defined via OrangeChartAbstract.assignSource
     *
     * @param {string} property
     * @return {object}
     */
  }, {
    key: "getCallbacks",
    value: function getCallbacks(property) {
      return Object.assign({}, this._default_data_callbacks, this._custom_data_callbacks.hasOwnProperty(property) ? this._custom_data_callbacks[property] : {});
    }

    /**
     * Defines axis configuration
     *
     * @param {string} axis
     * @param {object} config
     * @return {OrangeChartAbstract}
     */
  }, {
    key: "axis",
    value: function axis(_axis, config) {
      if (!this._axes.hasOwnProperty(_axis)) {
        throw new Error("Axis \"".concat(_axis, "\" is not allowed for this type of chart"));
      }
      if (!config.hasOwnProperty('sources') && !config.hasOwnProperty('source') && _axis === this.constructor.source_axis) {
        if (!this._source_mapping.length) {
          throw new Error("Assign sources before configuring axes");
        }
        config['sources'] = this._source_mapping.map(function (v) {
          return v.property;
        });
      }
      if (this.constructor.source_axis === 'x' && !config.hasOwnProperty('dynamic')) {
        if (_axis === 'x') {
          config['dynamic'] = true;
        } else if (_axis === 'y') {
          config['dynamic'] = false;
        }
      }
      this._axes[_axis].update(config, this._data);
      return this;
    }

    /**
     * Chart type
     *
     * @type {string}
     * @static
     */
  }, {
    key: "_get_basic_dimensions",
    value:
    /**
     * Basic dimensions of the chart
     *
     * @param {object} view
     * @return {{width:number, height:number}}
     * @protected
     * @abstract
     */
    function _get_basic_dimensions(view) {
      throw new Error('get _get_basic_dimensions should be overridden');
    }

    /**
     * Function for calculating label position for labels on X axis
     *
     * @type {null|{function(number, number, object): number}}
     * @protected
     */
  }, {
    key: "_x_axis_label_position_function",
    get: function get() {
      return null;
    }

    /**
     * Function for calculating label position for labels on Y axis
     *
     * @type {null|{function(number, number, object): number}}
     * @protected
     */
  }, {
    key: "_y_axis_label_position_function",
    get: function get() {
      return null;
    }

    /**
     * Renders Chart in the container
     *
     * @param {HTMLElement|string|null} el Container (string will be used as ID, null - just returns DOM SVG object)
     * @param {object} view Chart view configuration
     * @return {SVGSVGElement}
     */
  }, {
    key: "render",
    value: function render() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var view = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (typeof el === 'string') {
        if (!document.getElementById(el)) {
          throw new Error("HTML element with id \"".concat(el, "\" not found"));
        }
      }
      var svg = this._prepare_svg(view);
      return el === null ? svg.element : svg.render(el);
    }

    /**
     * Returns SVG Object converted to HTML string
     *
     * @param view Chart view configuration
     * @return {string}
     */
  }, {
    key: "toString",
    value: function toString() {
      var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._prepare_svg(view).toString();
    }

    /**
     * Generates OrangeSVG object
     *
     * @param {object} view Chart view configuration
     * @return {OrangeSVG}
     * @private
     */
  }, {
    key: "_prepare_svg",
    value: function _prepare_svg(view) {
      var svg = new OrangeSVG();
      var dimensions = this._get_basic_dimensions(view);
      var w = {
        'x1': 0,
        'y1': 0,
        'x2': dimensions.width,
        'y2': dimensions.height
      };
      var wc = Object.values(this._axes).reduce(function (a, c) {
        for (var _i = 0, _Object$entries = Object.entries(c.getOffsets(view)); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            k = _Object$entries$_i[0],
            v = _Object$entries$_i[1];
          a[k] = Math.max(a[k], v);
        }
        return a;
      }, {
        'x1': 0,
        'y1': 0,
        'x2': 0,
        'y2': 0
      });
      w.x1 += wc.x1;
      w.y1 += wc.y1;
      w.x2 -= wc.x2;
      w.y2 -= wc.y2;
      this._axes.x && this._axes.x.render(svg, view, w.x1, w.y1, w.x2, w.y2, this._x_axis_label_position_function);
      this._axes.y && this._axes.y.render(svg, view, w.x1, w.y1, w.x2, w.y2, this._y_axis_label_position_function);
      this._do_render(svg, view, w.x1, w.y1, w.x2, w.y2);
      svg.w = dimensions.width;
      svg.h = dimensions.height;
      return svg;
    }

    /**
     * Renders chart
     *
     * @param {OrangeSVG} svg
     * @param {object} view
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @abstract
     * @protected
     */
  }, {
    key: "_do_render",
    value: function _do_render(svg, view, x1, y1, x2, y2) {
      throw new Error('get _do_render should be overridden');
    }
  }], [{
    key: "allowed_axes",
    get: function get() {
      throw new Error('get allowed_axes should be overridden');
    }

    /**
     * Axis with dynamic values
     *
     * @type {string}
     * @static
     */
  }, {
    key: "source_axis",
    get: function get() {
      return 'y';
    }
  }, {
    key: "chart_type_code",
    get: function get() {
      throw new Error('get chart_type_code should be overridden');
    }
  }]);
  return OrangeChartAbstract;
}();
module.exports = OrangeChartAbstract;